export let props = ['data']
export let model = {}
export let computed = {}
